
const BaseUrl = {
    API_URL: process.env.REACT_APP_API_URL,
    SOCKET_URL:  process.env.REACT_APP_SOCKET_URL,
 
    // API_URL: 'https://godev.getopps.io:4000',
    // SOCKET_URL: 'https://godev.getopps.io:4000'
}

export default BaseUrl;